// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__JGWns","header":"PrivacyPolicy_header__RbEFS","paragraph":"PrivacyPolicy_paragraph__LGkDV","bulletList":"PrivacyPolicy_bulletList__1qznH"};